export const TOAST_MOBILE_ID = "single-mobile-toast";

export const TOAST_CONTAINER_DESKTOP_ID = "fs-toast-desktop-container";
export const TOAST_CONTAINER_MOBILE_ID = "fs-toast-mobile-container";
